import { Button } from '@trackman/web-shared-components';
import React from 'react';
import styled from 'styled-components';
import { buttonLightGrey, darkgrey } from 'styles/Colors';

export const Message = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const Buttons = styled.div`
  display: flex;
  gap: 16px;
`;

export const StyledButton = styled((props) => <Button {...props} />)`
  &&& {
    background-color: ${buttonLightGrey};
    color: ${darkgrey};
    white-space: nowrap;
  }
`;

export const NotificationCounter = styled.div`
  color: var(--Grayscale-White, #fff);
  font-family: Lato;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 21px;
  width: fit-content;
`;

export const Controls = styled.div`
  display: flex;
  gap: 16px;
  justify-content: space-between;
  align-items: center;
`;

export const NotificationWrapper = styled.div`
  background: #d0021b;
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const Content = styled.div`
  padding: 12px 0;
  display: flex;
  gap: 32px;

  svg {
    width: 16px;
    cursor: pointer;
  }
`;
